import React from "react";
import logo from "../assets/logo.png";
import { motion } from "framer-motion";

const LoadingScreen = ({ text = "Loading..." }) => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 z-50">

      {/* Glow background effect */}
      <div className="absolute w-72 h-72 bg-green-400/20 blur-3xl rounded-full animate-pulse" />

      {/* Logo */}
      <motion.img
        src={logo}
        alt="Company Logo"
        className="w-20 h-20 object-contain mb-6 drop-shadow-xl"
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      />

      {/* Brand name animation */}
      <motion.h1
        className="text-xl sm:text-2xl font-bold text-green-900 tracking-wide"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        CHELINKO
      </motion.h1>

      {/* Subtitle / loading text */}
      <motion.p
        className="mt-2 text-sm text-gray-600"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      >
        {text}
      </motion.p>

      {/* Animated dots */}
      <motion.div
        className="flex gap-1 mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="w-2 h-2 bg-green-700 rounded-full"
            animate={{
              y: [0, -6, 0],
            }}
            transition={{
              duration: 0.6,
              repeat: Infinity,
              delay: i * 0.15,
            }}
          />
        ))}
      </motion.div>
    </div>
  );
};

export default LoadingScreen;